import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { useContext, useMemo, useCallback } from 'react'
import buildLoyaltySelectedUpgradeKey from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import getLoyaltyTargetUpgradePackage from 'loyalty/lib/getLoyaltyTargetUpgradePackage'

function useLoyaltyOfferPageTargetRoomUpgrade(
  originPackage: App.Package | undefined,
): {
  selectedTargetUpgradePackage: App.Package | undefined,
  toggleTargetRoomUpgrade: (upgradeSelection: boolean) => void,
} {
  const { loyaltyTargetRoomUpgradesSelected, offer } = useContext(OfferPageStateContext)
  const targetUpgradePackage = getLoyaltyTargetUpgradePackage(offer, originPackage)

  const selectedUpgradeKey = useMemo(() => {
    if (!originPackage) return undefined
    return buildLoyaltySelectedUpgradeKey(originPackage, targetUpgradePackage)
  }, [originPackage, targetUpgradePackage])

  const offerPageDispatch = useOfferPageDispatch()

  const hasSelectedTargetRoomUpgrade = selectedUpgradeKey ? !!loyaltyTargetRoomUpgradesSelected?.[selectedUpgradeKey] : false

  const toggleTargetRoomUpgrade = useCallback((upgradeSelection: boolean) => {
    if (!selectedUpgradeKey) return
    offerPageDispatch({
      type: OfferPageActions.toggleLoyaltyTargetRoomUpgrade,
      selectedUpgradeKey,
      hasSelectedTargetRoomUpgrade: upgradeSelection,
    })
  }, [offerPageDispatch, selectedUpgradeKey])

  return {
    selectedTargetUpgradePackage: hasSelectedTargetRoomUpgrade ? targetUpgradePackage : undefined,
    toggleTargetRoomUpgrade,
  }
}

export default useLoyaltyOfferPageTargetRoomUpgrade
